// extracted by mini-css-extract-plugin
export default {"box":"IndividualField_box__YMtRF","txt":"IndividualField_txt__fKM3h","txtfield":"IndividualField_txtfield__o3gDU"};